import React, { useCallback, useMemo } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import CheckMarkImage from 'assets/images/svgs/ico_checkmark.svg';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';
import { setPlayerAudio } from 'store/player/actions';
import { selectPlayerAudio } from 'store/player/selectors';
import { selectActiveUserProfile } from 'store/user/selectors';

import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isWeb } from 'utils/responsiveness';

import SettingsRowItem from '../../components/RowItem';
import WebHeader from '../../components/WebHeader';
import { AUDIO_OPTIONS } from '../../constants';
import { SETTINGS_AUDIO_LANGUAGE } from '../../languagesConst';
import { AudioSettingItem } from '../../types';

function Audio() {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { background } = useSelector(selectLayoutConfig);
    const selectedAudio = useSelector(selectPlayerAudio);
    const selectedProfileId = useSelector(selectActiveUserProfile);

    useHeaderConfig({ isRoot: isWeb });

    const listStyle = useMemo(
        () => ({
            backgroundColor: background,
        }),
        [background],
    );

    const handleChangeAudio = useCallback(
        ({ id }: AudioSettingItem) => {
            if (selectedProfileId) {
                dispatch(setPlayerAudio(selectedProfileId, id));
            }
        },
        [dispatch, selectedProfileId],
    );

    const renderItem = useCallback(
        ({ item, index }: ListRenderItemInfo<AudioSettingItem>) => (
            <SettingsRowItem
                item={item}
                title={t(item.title)}
                onPress={handleChangeAudio}
                RightIcon={
                    selectedAudio === item.id ? CheckMarkImage : undefined
                }
                position={index + 1}
                total={AUDIO_OPTIONS.length}
                isSelected={selectedAudio === item.id}
            />
        ),
        [handleChangeAudio, selectedAudio, t],
    );

    return (
        <View style={[gStyles.settingsContainer, listStyle]}>
            {isWeb && (
                <WebHeader
                    title={t(SETTINGS_AUDIO_LANGUAGE)}
                    disableFocusOnMount
                />
            )}
            <FlatList
                style={gStyles.settingsContentContainer}
                nestedScrollEnabled
                data={AUDIO_OPTIONS}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                showsHorizontalScrollIndicator={false}
                accessibilityRole="menu"
            />
        </View>
    );
}

export default Audio;

function keyExtractor({ id }: AudioSettingItem) {
    return id;
}
